import { mdiLoading } from "@mdi/js";
import Icon from "@mdi/react";
import { FormEvent, useRef, useState } from "react"
import { marketingAgentgetIdService, marketingAgentQuestionService } from "src/services/MarketingAgentService";

export const MarketingAgentFormComponent = () => {
    const [question, setQuestion] = useState<string>('');
    // const [answer,setAnswer] = useState<string>('');
    const [isLoading, setIsLoading] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    const onSubmit = async(e: FormEvent) => {
        e.preventDefault();
        if(ref.current) {
            ref.current.innerHTML = '<span class="text-gray-400">Respuesta...</span>';
        }
        setIsLoading(true);
        const res = await marketingAgentgetIdService(question);
        
        if(res.success) {
            const interval = setInterval(async() => {
                const resp = await marketingAgentQuestionService(res.item.id);
                if(resp.success) {
                    if(resp.item.result) {
                        clearInterval(interval);
                        const regex = /!?\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;
                        const resultado = resp.item.result.replace(regex, '<img class="w-64 h-64 object-cover" src="$2" alt="$1" />');
                        if(ref.current) {
                            ref.current.innerHTML = resultado;
                        }
                        setIsLoading(false);
                    }
                } else {
                    setIsLoading(false);
                }
            }, 5000);
        } else {
            setIsLoading(false);
        }
    }
    
  return (
    <form className="p-4" onSubmit={onSubmit}>
        <div className="grid gap-1 items-center mb-5">
            <label htmlFor="">Ingrese su pregunta</label>
            <textarea
                autoComplete={'off'}
                rows={5}
                value={question}
                className="py-2 px-4 w-full rounded border border-gray-400 outline-none resize-none"
                placeholder="Preguntar..."
                onChange={(event) => {
                  setQuestion(event.target.value);
                }}
            />
        </div>

        <div className="grid gap-1 items-center mb-5">
            <label htmlFor="">Respuesta</label>
            <div ref={ref} className="py-2 px-4 w-full h-[500px] overflow-auto rounded border border-gray-400 outline-none resize-none">
                <span className="text-gray-400">Respuesta...</span>
            </div>
            {/* <textarea
                autoComplete={'off'}
                rows={15}
                value={answer}
                className="py-2 px-4 w-full rounded border border-gray-400 outline-none resize-none"
                placeholder="Respuesta..."
                readOnly
            /> */}
        </div>

        <div className="flex justify-end">
            <button
                type="submit"
                className="btn btn-sm flex gap-2"
                disabled={ isLoading }
            >
                Preguntar
                {isLoading && <Icon className="mr-1" size={.7} path={mdiLoading} spin />}
            </button>
        </div>
    </form>
  )
}
